<template>
  <div class="mk-button mk-connector-object"  @click="clickCallback">
    <div class="mk-connector-object__dummy"><Link /></div>
    <span class="mk-connector-object__disc">
      connector
    </span>
  </div>
</template>

<script>
/**
 * Selection Connector Object
 * @author David <david.prenninger@gmx.de>
 *
 * This component represents a Connector as part of the configuration.
 * It shows title and values and runs a callback when clicked.
 */
import Link from 'vue-material-design-icons/Link.vue';

export default {
  components: {
    Link,
  },
  props: {
    object: Object,
    clickCallback: Function,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-connector-object {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  border-radius: $br_md;
  border: 1px solid $c_primary_lighter;

  &__disc {
    margin-bottom: 5px;
  }

  &__dummy {
    font-size: 24px;
  }
}
</style>
